const FEATURE_HELP_URLS = {
  agent_bots: 'https://docs.lubb.co.za/guide/getting-started',
  agents: 'https://docs.lubb.co.za/guide/getting-started',
  audit_logs: 'https://docs.lubb.co.za/guide/getting-started',
  campaigns: 'https://docs.lubb.co.za/guide/getting-started',
  canned_responses: 'https://docs.lubb.co.za/guide/getting-started',
  channel_email: 'https://docs.lubb.co.za/guide/getting-started',
  channel_facebook: 'https://docs.lubb.co.za/guide/getting-started',
  custom_attributes: 'https://docs.lubb.co.za/guide/getting-started',
  dashboard_apps: 'https://docs.lubb.co.za/guide/getting-started',
  help_center: 'https://docs.lubb.co.za/guide/getting-started',
  inboxes: 'https://docs.lubb.co.za/guide/getting-started',
  integrations: 'https://docs.lubb.co.za/guide/getting-started',
  labels: 'https://docs.lubb.co.za/guide/getting-started',
  macros: 'https://docs.lubb.co.za/guide/getting-started',
  reports: 'https://docs.lubb.co.za/guide/getting-started',
  sla: 'https://docs.lubb.co.za/guide/getting-started',
  team_management: 'https://docs.lubb.co.za/guide/getting-started',
  webhook: 'https://docs.lubb.co.za/guide/getting-started',
  billing: 'https://lubb.co.za/contact',
  saml: 'https://docs.lubb.co.za/guide/getting-started',
  captain: 'https://docs.lubb.co.za/guide/getting-started',
  captain_billing: 'https://docs.lubb.co.za/guide/getting-started',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
